import React,{useEffect,useState} from 'react';
import { Container, Row, Col } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

import './ProductListLeftbar.styles.css';
import SlectInputField from '../SlectInputField/SlectInputField';
import DynamicProductList from '../DynamicProductList/DynamicProductList';
import productBanner from '../../mockups/productList.json'
import Axios from '../../lib/axios/axiosInstance';
import DynamicProductList_ListView from '../DynamicProductList/DynamicProductList_ListView';

const ProductListLeftbar = ({filter, products ,productBasename, baseUrl,reducer,dispatch,searchList=false}) => {
  
  const options = {
    margin: 0,
    responsiveClass: true,
    autoplay:true,
    nav: true,
    dots: false,
    loop: true,
    navText: ["<span></span>", "<span></span>"],
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 1,
      },
      600: {
        items: 1,
      },
      700: {
        items: 1,
      },
      1000: {
        items: 1,

      }
    },
  };

  const [banners, setBanners] = useState([]);
  const [partners, setPartners] = useState([]);
  const [view, setView] = useState('grid')

  const getBanners = async () => {
    await Axios.get('/cms/home-promo-item-banner')
    .then(function (response) {
        if (response.data) {
          if (response.data.item.length > 0) { 
            response.data.banner.forEach((element,i) => {
              // element.expdate=element.expdate.replace("2022",`202${2+i}`);
            });
            setBanners(response.data.banner);
          }
          else {
            setBanners([]);
          }
        }
    })
    .catch(function (error) {
      setBanners([]);
    });
};

useEffect(() => {
  if(products.banner){
    if(products?.banner){
      let abcd=productBasename;
      setBanners(products.banner)
    }else{
      // getBanners();
    }
  
    if(products?.partner){
      setPartners(products.partner)
    }
  }
}, [products])

const handleView =async (e) => {
  setView(e.target.value);
}

var RenderRevData = (data) =>{
  return (
    <>
    <OwlCarousel id="related-products-slider" className="product-flexslider hidden-buttons owl-theme" {...options}>
    {data.data.length>0 && data.data.map((item, index) => {
      return (
      <div className="item" key={index}>
        <Link to="/category"><img alt="" src={item.image || "images/category-img1.jpg"} /></Link>
        <div className="cat-img-title cat-bg cat-box">
          {/* <div className="small-tag" style={{color:"green", fontWeight:"bold", padding:0}}>{item?.text1 || "Back To School"}</div>
          <h2 className="cat-heading" style={{color:"green"}}>{item?.text2 || "New special collection"}</h2>
          <p style={{color:"green"}}>{item?.text3 || "Lorem ipsum dolor sit amet, consectetur adipiscing elit."} </p> */}
        </div>
      </div>
    )
    })}
    </OwlCarousel>
  </>
  );
};

  return (
    <>
      {!searchList &&
      <div className="category-description std">
        <div className="slider-items-products">

          <div className="slider-items">
            
            <RenderRevData data={banners}/>
            {/* <OwlCarousel id="related-products-slider" className="product-flexslider hidden-buttons owl-theme" {...options}>
              {productBanner && productBanner?.map(data => (
                data && data?.title === "banner" &&
                data?.products?.map(product => (
                  <div className="item">
                    <Link to="/category"><img alt="" src={product?.mainImageUrl || "images/category-img1.jpg"} /></Link>
                    <div className="cat-img-title cat-bg cat-box">
                      <div className="small-tag">{product?.subtitle || "Back To School"}</div>
                      <h2 className="cat-heading">{product?.title || "New special collection"}</h2>
                      <p>{product?.text || "Lorem ipsum dolor sit amet, consectetur adipiscing elit."} </p>
                    </div>
                  </div>
                  ||
                  <>
                    <div className="item">
                      <Link to="/category"><img alt="" src="images/category-img1.jpg" /></Link>
                      <div className="cat-img-title cat-bg cat-box">
                        <div className="small-tag">Back To School</div>
                        <h2 className="cat-heading">New special collection</h2>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. </p>
                      </div>
                    </div>

                    <div className="item">
                      <Link to="/category"><img alt="" src="images/category-img2.jpg" /></Link>
                      <div className="cat-img-title cat-bg cat-box">
                        <div className="small-tag">Big Sale</div>
                        <h2 className="cat-heading">New IT Gadgets</h2>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. </p>
                      </div>
                    </div>
                  </>
                ))
              ))}
            </OwlCarousel> */}
          </div>
        </div>
      </div>
      }
      {/* <button onClick={() => navigate(-1)}> back </button> */}
      <article className="col-main">
        <h2 className="page-heading"> <span className="page-heading-title">{productBasename}</span> </h2>
        
        <Row>
          <Col md={7} sm={5} />
          <Col sm={2} className="text-right sort-by">
            <label className="control-label" htmlfor="input-sort">View As:</label>
          </Col>

          <Col md={3} sm={3} className="text-right">
            <select name="product" id="products" style={{ width: "70%" }} onChange={handleView}>
              <option value="grid">Grid</option>
              <option value="list">List</option>
            </select>
          </Col>


        </Row>
        {view === 'grid' && <DynamicProductList key={baseUrl} filter={filter} productList={products?.items} baseUrl={baseUrl} dispatch={dispatch} searchList={searchList}/>}
        {view === 'list' && <DynamicProductList_ListView filter={filter} productList={products?.items} baseUrl={baseUrl} dispatch={dispatch} searchList={searchList}/>}
      </article>

    </>
  );
};

export default ProductListLeftbar;
